export const minsConvertToHourAndMins = (mins: number | string): string => {
  let result = '';
  let hour = Math.trunc(Number(mins) / 60);
  let minutes = Number(mins) % 60;
  let minsToNumber = Number(mins);

  if (minsToNumber < 60) {
    result = `${minsToNumber} minutes`;
  }
  if (minsToNumber % 60 === 0) {
    result = `${hour} hour`;
  }
  if (minsToNumber > 60 && minsToNumber % 60 !== 0) {
    result = `${hour} hour ${minutes} minutes`;
  }

  return result;
};
